import {exportToCSV, exportToPDF} from '../../../../utils/exportUtils';
import React, {useState, useRef} from 'react';
import AppCard from '../../../../components/ui/AppCard';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import apiClient from "../../../../services/api-client";
// import { MenuItem } from 'primereact/menuitem';

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import {useMountEffect} from 'primereact/hooks';
import StorageHelper from '../../../../utils/storage-helper';

const PaymentsReportTable = () => {
    const [Users, setUsers] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');

    const dt = useRef(null);

    const cols = [
        {field: 'id', header: 'ID'},
        {field: 'policyNumber', header: 'Policy Number'},
        {field: 'productName', header: 'Product Name'},
        {field: 'payerName', header: 'Payer Name'},
        {field: 'billingAddress', header: 'Billing Address'},
        {field: 'mobileNumber', header: 'Phone Number'},
        {field: 'emailAddress', header: 'Email'},
        {field: 'amount', header: 'Amount'},
        {field: 'paymentStatus', header: 'Payment Status'},
        {field: 'paymentReference', header: 'Payment Reference'},
        {field: 'notes', header: 'Payment Notess'},
        {field: 'easipolPaymentResponse', header: 'Easipol Payment Status'},
        {field: 'pollUrl', header: 'Paynow Verification Link'},
        {field: 'timeStamp', header: 'Timestamp'}
    ];

    cols.map((col) => ({title: col.header, dataKey: col.field}));


    useMountEffect(() => {
        fetchUsers();

    }, []); // eslint-disable-line react-hooks/exhaustive-deps




    const fetchUsers = async () => {
        try {
            await apiClient.get('payment/report', {
                headers: {
                    Authorization: 'Bearer ' + (StorageHelper.get('token'))
                }
            }).then((response) => {
                //console.log(response);
                if (response.data.status === "SUCCESS") {
                    setUsers((response.data.responseBody));
                } else {
                    //console.log(response.data.status);
                }
            });

        } catch (error) {
            //console.log(error)
        }
    };





    const onGlobalFilter = (event) => {
        setGlobalFilter(event.target.value);
    };

    const header = (
        <div className="flex flex-col sm:flex-row gap-4 justify-between items-center w-full">
            <div className="relative w-full max-w-xs">
                <i className="pi pi-search absolute left-3 top-1/2 -translate-y-1/2 text-base-content/50"></i>
                <input
                    type="text"
                    className="input input-bordered w-full pl-10 h-10 shadow-sm bg-base-100 rounded-full"
                    placeholder="Search..."
                    value={globalFilter}
                    onChange={onGlobalFilter}
                />
            </div>
            <div className="flex items-center gap-3 ml-auto">
                <div className="dropdown dropdown-end">
                    <div tabIndex={0} role="button"
                         className="btn btn-outline btn-ghost h-10 min-h-0 shadow-sm rounded-full">
                        <i className="pi pi-file-export"></i> Export
                    </div>
                    <ul tabIndex={0}
                        className="dropdown-content z-[99] menu p-2 shadow-sm bg-base-100 border border-base-200 rounded-box w-52 mt-2">
                        <li><button type="button" onClick={() => exportToCSV(dt, 'Payments')}><i
                            className="pi pi-file-excel text-success"></i> Download CSV</button></li>
                        <li><button type="button" onClick={() => exportToPDF(dt, 'Payments', 'Payments Report')}><i
                            className="pi pi-file-pdf text-error"></i> Download PDF</button></li>
                    </ul>
                </div>
            </div>
        </div>
    );


    const paymentStatusBodyTemplate = (rowData) => {
        const status = rowData.paymentStatus;
        if (!status) return <span
            className="badge border-0 font-semibold text-xs bg-base-200/50 text-base-content">-</span>;
        const upperStatus = status.toUpperCase();
        let bg = 'bg-base-200/50', text = 'text-base-content';
        if (upperStatus === 'PENDING') {
            bg = 'bg-warning/10';
            text = 'text-warning';
        } else if (upperStatus === 'SUCCESS' || upperStatus === 'COMPLETED' || upperStatus === 'SUCCESSFUL') {
            bg = 'bg-success/10';
            text = 'text-success';
        } else if (upperStatus === 'FAILED' || upperStatus === 'DECLINED') {
            bg = 'bg-error/10';
            text = 'text-error';
        } else if (upperStatus === 'PROCESSING') {
            bg = 'bg-info/10';
            text = 'text-info';
        }
        return <span className={`badge border-0 font-semibold text-xs ${bg} ${text}`}>{status}</span>;
    };

    const easipolStatusBodyTemplate = (rowData) => {
        const status = rowData.easipolPaymentResponse;
        if (!status) return <span className="badge badge-outline font-semibold text-xs badge-ghost">-</span>;
        const upperStatus = String(status).toUpperCase();
        let color = 'badge-ghost';
        if (upperStatus === 'PENDING') {
            color = 'badge-warning';
        } else if (upperStatus.includes('SUCCESS') || upperStatus === 'COMPLETED') {
            color = 'badge-success';
        } else if (upperStatus.includes('FAIL') || upperStatus === 'DECLINED' || upperStatus.includes('ERROR')) {
            color = 'badge-error';
        } else if (upperStatus === 'PROCESSING') {
            color = 'badge-info';
        }
        return <span className={`badge badge-outline font-semibold text-xs ${color}`}>{status}</span>;
    };


    const humanReadableDateBodyTemplate = (rowData, field) => {
        const dateVal = rowData[field];
        if (!dateVal) return '-';
        try {
            return new Date(dateVal).toLocaleString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: true
            });
        } catch (e) {
            return dateVal;
        }
    };

    return (


        <div className="w-full">
            <AppCard title="Payments Report">
                <DataTable
                    paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]}
                    ref={dt}
                    value={Users}
                    header={header}
                    globalFilter={globalFilter}
                    emptyMessage="No payments found"
                    paginatorTemplate="CurrentPageReport RowsPerPageDropdown PrevPageLink PageLinks NextPageLink"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                >
                    {cols.map((col, index) => (
                        <Column key={index} field={col.field} header={col.header}
                                body={col.field === 'paymentStatus' ? paymentStatusBodyTemplate : col.field === 'easipolPaymentResponse' ? easipolStatusBodyTemplate : col.field === 'timeStamp' ? (rowData) => humanReadableDateBodyTemplate(rowData, col.field) : null}/>
                    ))}
                </DataTable>
            </AppCard>
        </div>
    );
};

export default PaymentsReportTable;
